import React, { Component } from 'react'
import ProfessionDetail from '../Profession/Detail'
import './ProfessionDetail.less'

class Detail extends Component {

  handleBack() {
    const { history } = this.props
    history.push(`/majorwishlist`)
  }

  render() {
    return (
      <div className="major-wish-list-wrapper">
        <ProfessionDetail isRenderBackBtn={false} {...this.props} />
        <div className="bottom-btn">
          <button className="primary full" onClick={this.handleBack.bind(this)}>返回我的专业意向清单</button>
        </div>
      </div>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/pages/MajorWishList/ProfessionDetail.js